window.addEventListener("load",function() {
  document.querySelectorAll('.custom-collection-card-tab').forEach((tab, index) => {
  tab.addEventListener('click', function () {
    if (!this.classList.contains('active')) {
      const tabs = this.parentElement.querySelectorAll('.custom-collection-card-tab')
      tabs.forEach(t => t.classList.remove('active'))
      this.classList.add('active')
      const container = this.closest('.custom-collection-cards-container')
      const contents = container.querySelectorAll('.custom-collection-card-content')
      contents.forEach(c => c.classList.remove('active'))
      if (contents[index]) {
        contents[index].classList.add('active')
      }
    }
  })
})
if (window.innerWidth < 768) {
  const nav = document.querySelectorAll('.mobile-fixed-header')[0]
  console.log(nav);
  const threshold = 300
  const transparentClass = 'mobile-transparent'
  function updateNavbar() {
    const y = window.scrollY || document.documentElement.scrollTop
    if(nav){
  if (y >= threshold) {
      nav.classList.remove(transparentClass)
    } else {
      nav.classList.add(transparentClass) 
    }
    }
  
  }
  updateNavbar()
  window.addEventListener('scroll', updateNavbar, { passive: true })
  }

})
